import { warn } from '@execonline-inc/logging';
import {
  error,
  filtered,
  FilterError,
  filtering,
  Filtering,
  FilterOption,
  FilterOptionsResource,
  FilterValue,
  NewState,
  optionSelected,
  State,
} from './Types';
import { assertNever } from '@kofno/piper';

export const warnAndSetErrorState = (setState: (value: NewState) => void) => (e: FilterError) => {
  const message = 'Error loading options';
  warn(message, e);
  setState(error(message));
};

export const setFilteringState =
  (state: State, setState: (value: NewState) => void) => (filterBy: FilterValue) => {
    switch (state.kind) {
      case 'ready':
      case 'filtered':
      case 'option-selected':
        setState(filtering(filterBy));
        break;
      case 'filtering':
      case 'error':
        break;
      default:
        assertNever(state);
    }
  };

export const setOptionSelectedState =
  (state: State, setState: (value: NewState) => void) => (selectedValue: FilterOption) => {
    switch (state.kind) {
      case 'filtered':
      case 'option-selected':
        setState(optionSelected(selectedValue, state.optionsResource));
        break;
      case 'ready':
      case 'filtering':
      case 'error':
        break;
      default:
        assertNever(state);
    }
  };

export const setFilteredState =
  (state: Filtering, setState: (value: NewState) => void) =>
  (optionsResource: FilterOptionsResource) =>
    setState(filtered(optionsResource, state.filterBy));
